import { render, staticRenderFns } from "./ElementManualBonusTableColumn.vue?vue&type=template&id=72b0e074"
import script from "./ElementManualBonusTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementManualBonusTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports